import React from "react";
import Layout from "../../../component/Layout";
import RRTestHeader from "../Test/RRTestHeader";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import { Link } from "react-router-dom";

const RRTrainStep3 = () => {
  return (
    <Layout>
      <div className="bg-[#F6F6F6] h-full pb-5 overflow-y-auto">
        <RRTestHeader />
        <div className="w-full max-w-2xl mx-auto px-5">
          <div className="relative text-start mb-[30px]">
            <p className="text-black text-base font-normal pl-5 capitalize">
              monday
            </p>
            <Link to="/rrtrainstep2">
              <span className="absolute left-0 top-1/2 -translate-y-1/2">
                <ArrowL />
              </span>
            </Link>
          </div>
          <div className="pt-[30px] mx-auto">
            <div style={{ width: 174, height: 174 }} className="mx-auto">
              <CircularProgressbarWithChildren
                strokeWidth={5}
                value={23}
                styles={buildStyles({
                  pathColor: "#6D48C1", // Progress path color
                  trailColor: "#E5E5E5", // Background path color
                })}
              >
                <p className="text-black text-5xl font-normal mb-2">23</p>
                <span className="text-[#A5A5A5] text-[12px] font-normal leading-[91%] uppercase">
                  target speed
                </span>
              </CircularProgressbarWithChildren>
            </div>
          </div>
          <div className="my-[30px]">
            <div className="flex flex-row items-center justify-between gap-[20px] border-black/20 border-b py-[14px]">
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  REPS
                </p>
                <p className="text-black text-sm font-normal">35lbs</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  Distance
                </p>
                <p className="text-black text-sm font-normal">250m</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  LOAD
                </p>
                <p className="text-black text-sm font-normal">8.55</p>
              </div>
              <div className="cursor-pointer w-fit h-fit">
                <ArrowD />
              </div>
            </div>
            <div className="flex flex-row items-center justify-between gap-[20px] border-black/20 border-b py-[14px]">
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  REPS
                </p>
                <p className="text-black text-sm font-normal">35lbs</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  Distance
                </p>
                <p className="text-black text-sm font-normal">250m</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  LOAD
                </p>
                <p className="text-black text-sm font-normal">8.55</p>
              </div>
              <div className="cursor-pointer w-fit h-fit">
                <ArrowD />
              </div>
            </div>
            <div className="flex flex-row items-center justify-between gap-[20px] border-black/20 border-b py-[14px]">
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  REPS
                </p>
                <p className="text-black text-sm font-normal">35lbs</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  Distance
                </p>
                <p className="text-black text-sm font-normal">250m</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  LOAD
                </p>
                <p className="text-black text-sm font-normal">8.55</p>
              </div>
              <div className="cursor-pointer w-fit h-fit">
                <ArrowD />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-5">
            <div className="relative w-full max-w-[144px] border-b border-black mx-auto">
              <span className="uppercase text-[#a5a5a5] text-xs font-normal mx-auto w-fit block">
                actual Speed
              </span>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Your max speed"
                  className="bg-transparent w-full outline-none p-[10px_30px_10px_0px] placeholder:text-[#ADADAD] text-black text-base font-normal"
                />
                <span className="absolute right-0 top-1/2 -translate-y-1/2">
                  <Add />
                </span>
              </div>
            </div>
            <div className="border-black/20 border-t pt-[18px]">
              <p className="text-black text-xs font-normal">
                Lorem ipsum dolor sit amet consectetur. Cras sit eget velit
                tristique dictum justo. Cras mi odio id et maecenas nisl odio
                vitae commodo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RRTrainStep3;

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Add = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 21 22"
      fill="none"
    >
      <path
        d="M10.5 1V21M0.5 11C8.31049 11 12.6895 11 20.5 11"
        stroke="#000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const ArrowD = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
    >
      <path
        d="M13 1L7 7L1 1"
        stroke="#000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
